export const REGEX_PASSWORD =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[-/:;()$&@“.,?!’{}#%^*+=_|~<>£€¥₩•"×÷`~'[\]\\]).{8,50}$/;

export const REGEX_WEBSITE =
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;

export const REGEX_PHONE = /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/;

export const REGEX_EMAIL =
  // eslint-disable-next-line no-useless-escape
  /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

export const REGEX_SPECIAL =
  // eslint-disable-next-line no-useless-escape
  /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;

export const REGEX_DIGIT = /\d/;

export const REGEX_CASE = /^(?=.*[A-Z])(?=.*[a-z]).*$/;

export const REGEX_FULLNAME = /([a-zA-ZğüşöçıİĞÜŞÖÇ]+\s)+[a-zA-ZğüşöçıİĞÜŞÖÇ]+/;

export const REGEX_NUMERIC = /\d/;
